import { AfterViewInit, Component, Input } from '@angular/core';
import { GeneralService } from 'src/app/shared/services/general.service';
import { AdDefaults } from '../ad-default';


@Component({
    selector: 'promotions',
    templateUrl: './promotions.component.html',
    styleUrls: ['./promotions.component.scss']
})
export class PromotionsComponent extends AdDefaults implements AfterViewInit {

    @Input() info : any;
    @Input() plain : any = false;
    @Input() swiperConfig : any = {}

    galleryInit = false;

    constructor( 
        protected gs : GeneralService
    ){
        super(gs);
    }
    
    ngAfterViewInit(): void {
        setTimeout(()=> this.galleryInit = true, 300);
        console.log(this.swiperConfig, this.info.promotionRealtorImages, this.info);
    }

}